import { inject, Injectable } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { PeriodForm } from '@features/insured/models/period/period.model'

@Injectable({
  providedIn: 'root'
})
export class PeriodFormService {
  private readonly fb = inject(FormBuilder)

  public buildForm(required = false): FormGroup<PeriodForm> {
    return this.fb.group({
      uuid: this.fb.control<string | null>(null, { validators: [required ? Validators.required : Validators.nullValidator] }),
      name: this.fb.control<string | null>(null),
      periodFrom: this.fb.control<string | null>(null),
      periodTo: this.fb.control<string | null>(null),
      label: this.fb.control<string | null>(null),
    }, { updateOn: 'blur' }) as FormGroup<PeriodForm>
  }

}
